import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';
import { AlertService } from '../core/services/alert.service';
import { Notifications } from '../core/models/notifications';
import * as dayjs from 'dayjs';
import { map } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  //TODO 사이드 메뉴 리스트 넣기
  menu = [
    {
      label: '대시 보드',
      icon: 'bx-home',
      link: '/dashboard',
    },

    {
      label: '회원 관리',
      icon: 'bx-user',
      subItems: [
        {
          label: '회원 관리',
          link: '/user-list',
        },
        {
          label: '1:1 문의',
          link: '/inquiry-list',
        },
      ],
    },

    {
      label: '커뮤니티 관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '행콕 게시물 관리',
          link: '/hangcok-post-list',
        },
        {
          label: '게시물 관리',
          link: '/post-list',
        },
        {
          label: '댓글 관리',
          link: '/comment-list',
        },
      ],
    },

    {
      label: '컨텐츠 관리',
      icon: 'bx bx-customize',
      subItems: [
        {
          label: '이모티콘 관리',
          link: '/emoji-list',
        },
        {
          label: '메뉴 아이콘 관리',
          link: '/icon-menu-list',
        },
      ],
    },

    {
      label: '배너 관리',
      icon: 'bx bx-windows',
      subItems: [
        {
          label: '친구 배너',
          link: '/banner-friend-list',
        },
        {
          label: '채팅 배너',
          link: '/banner-chat-list',
        },
        {
          label: '커뮤니티 배너',
          link: '/banner-community-list',
        },
        {
          label: '더 보기 배너',
          link: '/banner-more-list',
        },
      ],
    },

    {
      label: '신고 관리',
      icon: 'bx-error',
      subItems: [
        {
          label: '게시물 신고 관리',
          link: '/report-post-list',
        },
        {
          label: '댓글 신고 관리',
          link: '/report-comment-list',
        },
        {
          label: '사용자 신고 관리',
          link: '/report-user-list',
        },
      ],
    },

    {
      label: '서비스 / 정보 관리',
      icon: 'bx-note',
      subItems: [
        {
          label: '공지사항',
          link: '/notice-list',
        },
        {
          label: '자주 묻는 질문',
          link: '/faq-list',
        },
        {
          label: '개인정보 처리방침/ 이용약관',
          link: '/terms',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService,
    private alertService: AlertService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.getNotifications();
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      localStorage.removeItem('admin');
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  // 알림 데이터 불러오기
  notifications$: Notifications | any;
  unReadLength: number = 0;
  async getNotifications() {
    this.notifications$ = this.db
      .collection$(`notifications`, (ref) =>
        ref
          .where('uuid', '==', '8Ha0YrDSP9ZaJGdOu5QdYAGlT542')
          .where('deleteSwitch', '==', false)
          .orderBy('dateCreated', 'desc')
      )
      .pipe(
        map((notifications: Notifications[] | any) => {
          this.unReadLength = notifications.filter(
            (notification) => !notification.readSwitch
          ).length;

          return notifications;
        })
      );
  }

  // 알림내역 시간 표시
  displayedAt(dateCreated: string) {
    const milliSeconds = new Date().getTime() - dayjs(dateCreated).valueOf();
    const seconds = milliSeconds / 1000;
    if (seconds < 60) return `방금 전`;
    const minutes = seconds / 60;
    if (minutes < 60) return `${Math.floor(minutes)}분 전`;
    const hours = minutes / 60;
    if (hours < 24) return `${Math.floor(hours)}시간 전`;
    const days = hours / 24;
    if (days < 7) return `${Math.floor(days)}일 전`;
    const months = days / 30;
    if (months < 12) return `${Math.floor(months)}개월 전`;
    return dayjs(dateCreated).format('YY-MM-DD');
  }

  // 알림 [전체삭제]
  async delete() {
    const ok = await this.alertService.successConfirm(
      '',
      '전체 삭제하시겠습니까?',
      '확인'
    );

    if (ok) {
      this.notifications$.forEach((notifications: Notifications[]) => {
        notifications.forEach((notification) => {
          this.db.updateAt(`notifications/${notification.id}`, {
            readSwitch: true,
            deleteSwitch: true,
          });
        });
      });
    }
  }

  // 알림 [상세]
  async alarm(item) {
    await this.db.updateAt(`notifications/${item.id}`, {
      readSwitch: true,
    });

    // 1:1 문의 이동
    if (item.link === 'inquiry-list') {
      this.router.navigate(['/inquiry-list']);
    }
    // 게시글 신고관리 이동
    else if (item.link === 'report-post-list') {
      this.router.navigate(['/report-post-list']);
    }
    // 댓글 신고관리 이동
    else if (item.link === 'report-comment-list') {
      this.router.navigate(['/report-comment-list']);
    }
    // 사용자 신고관리 이동
    else if (item.link === 'report-user-list') {
      this.router.navigate(['/report-user-list']);
    } else {
      return;
    }
  }
}
